// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useEffect, useContext, Fragment, useRef, useState} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import styles from './index.module.less';
import {Button} from '../../../../hola/pub/lib/button';
import Icon_arrow_right from '../../../../hola/pub/img/hola2023/icons/24/arrow_right.svg';
import Icon_chart_pie from '../../img/icons/24/chart_pie.svg';
import Icon_gift from '../../img/icons/24/gift.svg';
import Icon_slider from '../../img/icons/24/slider02.svg';
import {perr, perr_www_visit} from 'hola_pub_util';
// @ts-ignore
import {Gradient} from '../../../../hola/pub/lib/gradient.js';
import {use_qs} from '../../../../hola/pub/lib/use_qs';
import {if_set} from 'zutil';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {Map} from '../../ui/landings/map';
import {Faq_section} from '../../ui/toolip/faq_section';
import {Lottie} from '../../../../hola/pub/lib/lottie';
import {use_scrolled} from '../../../../hola/pub/ui_utils';
import {use_intercom} from '../../../../hola/pub/ui/intercom';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import anim_styles from '../../ui/animation.module.less';
import {HP_cards, HP_card} from '../../ui/hp_cards';
import {Products_cards} from '../../ui/free_proxy/product_cards';
import {Use_case_bubbles} from '../../ui/use_case_bubbles';
import {Review_slides} from '../../ui/landings/review_slides';
import {Carusel} from '../../ui/carusel';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {use_show_promo} from '../../ui/free_proxy/use_show_promo';
import {Input} from '../../../../hola/pub/lib/input';
import {Select} from '../../../../hola/pub/lib/select';
import {Textarea} from '../../../../hola/pub/lib/textarea';
import {Editor} from '../../../../shared/editor/editor';
import {Dynamic_heading, Title_header_select} from '../../../../shared/editor/title_header_select';

const Gradient_hero = ()=>{
    const {theme} = useContext(Settings_context);
    const {show_promo} = use_show_promo();
    const qs = use_qs();
    const gradient_ref = useRef();
    const hero_ref = useRef<HTMLDivElement>();
    const {T} = use_translation_v({no_defaults: true});
    useEffect(()=>{
        if (!gradient_ref.current || !hero_ref.current)
            return;
        const vars = {};
        if_set(qs.color1 && '#'+qs.color1, vars, 'gradient-color-1');
        if_set(qs.color2 && '#'+qs.color2, vars, 'gradient-color-2');
        if_set(qs.color3 && '#'+qs.color3, vars, 'gradient-color-3');
        if_set(qs.color4 && '#'+qs.color4, vars, 'gradient-color-4');
        // if_set(qs.color5 && '#'+qs.color5, vars, 'gradient-color-5');
        // if_set(qs.color6 && '#'+qs.color6, vars, 'gradient-color-6');
        // if_set(qs.color7 && '#'+qs.color7, vars, 'gradient-color-7');
        // if_set(qs.color8 && '#'+qs.color8, vars, 'gradient-color-8');
        if_set(qs.gradient_op && +qs.gradient_op/100, vars, 'gradient_op');
        if_set(qs.animation_op && +qs.animation_op/100, vars, 'animation_op');
        if_set(qs.underlay_op && +qs.underlay_op/100, vars, 'underlay_op');
        if_set(qs.content_op && +qs.content_op/100, vars, 'content_op');
        if_set(qs.gradient_pos, vars, 'gradient_pos');
        if_set(qs.animation_pos, vars, 'animation_pos');
        if_set(qs.underlay_pos, vars, 'underlay_pos');
        Object.keys(vars).forEach(k=>{
            hero_ref.current.style.setProperty(`--${k}`, vars[k]);
        });
        if (qs.no_animation)
            return;
        const on_interact = ()=>{
            const gradient = new Gradient();
            // @ts-ignore
            gradient.initGradient('#gradient-canvas');
            window.removeEventListener('scroll', on_interact);
            window.removeEventListener('mousemove', on_interact);
        };
        window.addEventListener('scroll', on_interact);
        window.addEventListener('mousemove', on_interact);
    }, [gradient_ref.current, hero_ref.current]);
    const hero_cls = cn(styles.gradient_hero, {
        [styles.no_animation]: qs.no_animation,
    });
    const caption = show_promo ? 'Try now for free' : 'Try now';
    return <div ref={hero_ref} className={hero_cls}>
      <canvas ref={gradient_ref} id="gradient-canvas" data-transition-in/>
      <div className={cn(theme.container, styles.hero)}>
        <div className={cn(styles.hero_top, anim_styles.hero_showup_1)}>
          <p className={cn(theme.mono12, styles.uptime)}>
            <Lottie autoplay loop width="20px" height="14px"
              src={toolip_img_url('animation/uptime.json')}/>
            <span><T>Uptime: <b>99.9%</b></T></span>
          </p>
        </div>
        <div className={styles.hero_text_wrapper}>
          <h1 className={cn(styles.hero_title, anim_styles.hero_showup_2)}>
            <T>Lightning-Fast Proxies.<br/> Global IP Variety.</T></h1>
          <p className={cn(theme.u1, styles.hero_text,
            anim_styles.hero_showup_2)}><T>Get the perfect proxy, built for
              your needs</T></p>
          <Button caption={<Fragment><T>{caption}</T> <Icon_arrow_right/>
            </Fragment>}
            size={'lg'} no_jump to={'/dashboard'} fit
            on_click={()=>{
              perr({id: 'toolip_homepage_get_started_top_click'});
            }} cls={cn(styles.hero_cta, anim_styles.hero_showup_3)}
          />
          <p className={cn(theme.p4, theme.med, styles.hero_cta_text,
            anim_styles.hero_showup_3)}>
            <T>Free proxies | No credit card required</T>
          </p>
        </div>
      </div>
    </div>;
};

const feature_slides = cta_caption=>[
    {
        id: 'easy_setup',
        title: <div className={styles.feature_slide_title}>
          <span><Icon_chart_pie/> Easy Setup</span>
          <h4>Super Simple</h4>
        </div>,
        text: `At any given moment, you will have a real time view of the
            status of your account, so you always stay on top of your usage
            and spend.`,
        img: <img className="lazyload"
          data-src={toolip_img_url('homepage/easy_setup.svg')}/>,
        cta: {
            caption: cta_caption,
            to: '/dashboard',
        },
    },
    {
        id: 'free_tier',
        title: <div className={styles.feature_slide_title}>
          <span><Icon_gift/> TRY FOR FREE</span>
          <h4>Have a free run with our <br/>1-week trial plan</h4>
        </div>,
        text: `5 free toolip Proxies for you to try out. On the house. We won't
            even ask you for your credit card details! Go ahead, take them for
            a test drive.`,
        img: <img className="lazyload"
          data-src={toolip_img_url('homepage/free_tier.svg')}/>,
        cta: {
            caption: cta_caption,
            to: '/dashboard',
        },
    },
    {
        id: 'customizable',
        title: <div className={styles.feature_slide_title}>
          <span><Icon_slider/> Customizable</span>
          <h4>Huge Selection</h4>
        </div>,
        text: `Choose from over 70+ million proxies in over 195 countries
            countries and get accurate, timely data to accomplish your proxy
            tasks.`,
        img: <img className="lazyload"
          data-src={toolip_img_url('homepage/customizable.svg')}/>,
        cta: {
            caption: cta_caption,
            to: '/dashboard',
        },
    },
];

export interface I_feature_slide {
    id: string;
    icon: string;
    pretitle: string;
    title: string;
    text: string;
    img: string;
    img_alt: string;
    cta_caption: string;
    to: string;
}

const icons_map = {
    Icon_chart_pie: Icon_chart_pie,
    Icon_gift: Icon_gift,
    Icon_slider: Icon_slider,
};
const items_icons = [
    {
        value: 'Icon_chart_pie',
        rendered_item: <div>Icon_chart_pie <Icon_chart_pie /></div>,
        title: 'Icon_chart_pie',
    },
    {
        value: 'Icon_gift',
        rendered_item: <div>Icon_gift <Icon_gift /></div>,
        title: 'Icon_gift',
    },
    {
        value: 'Icon_slider',
        rendered_item: <div>Icon_slider <Icon_slider /></div>,
        title: 'Icon_slider',
    },
];

const prepare_slides_from_props = (slides: I_feature_slide[])=>{
    return slides.map(sl=>{
        const Icon = icons_map[sl.icon] || Icon_chart_pie;
        const img = sl.img.replace(`https://toolip.io/wp-content`,
            `https://cdn4.toolip.io/wp-content`);
        return {
            ...sl,
            title: <div className={styles.feature_slide_title}>
              <span><Icon/> {sl.pretitle}</span>
              <h4>{sl.title}</h4>
            </div>,
            img: <img className="lazyload" data-src={img} alt={sl.img_alt}/>,
            cta: {
                caption: sl.cta_caption,
                to: sl.to,
            },
        };
    });
};

export interface I_hp_feature_slide_props {
    title?: string;
    title_tag?: string;
    description?: string;
    slides?: I_feature_slide[];
}
export interface I_hp_feature_slide_ed_props {
    value: I_hp_feature_slide_props;
    on_change: (value:I_hp_feature_slide_props)=>void;
    on_cancel: ()=>void;
}

export const HP_feature_slides_editor = (props:I_hp_feature_slide_ed_props)=>{
    const [state, set_state] = useState(props.value || {});
    useEffect(()=>{
        set_state(props.value);
    }, [props.value]);
    const slides = state.slides || [];
    return <div>
      <Input size={'sm'} label={'title'} value={state.title || ''}
        on_change={v=>set_state({...state, title: v})}/>
      <Title_header_select value={state.title_tag} on_select={v=>
        set_state({...state, title_tag: v})}/>
      <Input size={'sm'} label={'description'} value={state.description || ''}
        on_change={v=>set_state({...state, description: v})}/>
      <p>Slides:</p>
      {slides.map((sl, i)=>{
        const change_slide = (field, value)=>{
            const slides_new = [...slides];
            slides_new[i] = {...slides_new[i]};
            slides_new[i][field] = value;
            set_state({...state, slides: slides_new});
        };
        return <div className={styles.one_slide_edit} key={i}>
          <Select items={items_icons} value={sl.icon} on_select={(n, v)=>{
            change_slide('icon', v);
          }} size={'sm'}/>
          <Input size={'sm'} label={'pretitle'} value={sl.pretitle || ''}
            on_change={v=>change_slide('pretitle', v)}/>
          <Input size={'sm'} label={'title'} value={sl.title || ''}
            on_change={v=>change_slide('title', v)}/>
          <Textarea placeholder={'text'} value={sl.text || ''}
            on_change={v=>change_slide('text', v)}/>
          <Input size={'sm'} label={'cta_caption'} value={sl.cta_caption || ''}
            on_change={v=>change_slide('cta_caption', v)}/>
          <Input size={'sm'} label={'to'} value={sl.to || ''}
            on_change={v=>change_slide('to', v)}/>
          <Input size={'sm'} label={'img'} value={sl.img || ''}
            on_change={v=>change_slide('img', v)}/>
          <Input size={'sm'} label={'Img Alt'} value={sl.img_alt || ''}
            on_change={v=>change_slide('img_alt', v)}/>
        </div>;
      })}
      <Button caption={'Add slide'} size={'sm'}
        on_click={()=>{
          set_state({...state, slides: [...slides, {
            id: `id${Date.now()}`,
            icon: 'Icon_chart_pie',
            pretitle: 'text after icon',
            title: 'Title of slide',
            text: 'Text inside the slide',
            img: 'https://toolip.io/wp-content/uploads/2024/07/'
              +'Group-1143422.png',
            img_alt: 'alt text',
            cta_caption: 'Get started',
            to: '/dashboard',
          }]});
        }}/>
      <br/>
      <Button caption={'Save'} size={'sm'}
        on_click={()=>props.on_change(state)}/>
      <Button caption={'Cancel'} size={'sm'} on_click={()=>props.on_cancel()}/>
    </div>;
};
export const HP_feature_slides = (props:I_hp_feature_slide_props)=>{
    const {theme} = useContext(Settings_context);
    const {show_promo} = use_show_promo();
    const cta_caption = show_promo ? 'Get started' : 'Try now';
    const {debug_tr} = use_qs();
    const {width, is_client} = use_screen();
    const slides_conf = props?.slides ? prepare_slides_from_props(props.slides)
        : feature_slides(cta_caption);
    const slides = slides_conf.map(s=>{
        return <HP_card key={s.id} {...s} cls={styles.hp_feature_slide} show
          color="light" />;
    });
    const {T} = use_translation_v({no_defaults: true});
    const title = props.title || 'Intuitive and simple to use';
    const description = props.description
      || 'Our features are custom made to optimize your workflow';
    return <section className={styles.hp_feature_slides}>
      <div className={styles.bg}/>
      <Dynamic_heading tag={props.title_tag}><T>{title}</T>
      </Dynamic_heading>
      <p className={theme.u1}><T>{description}</T></p>
      {(is_client||debug_tr) && <Carusel items={slides}
        slide_width={width < 768 ? 335 : width < 1024 ? 450 : 931}
        slide_height={width < 768 ? 392 : 416}
        list={width < 768 ? 3 : undefined}
      />}
    </section>;
};

export const HP_global = ({cls=''})=>{
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    return <section className={cn(styles.hp_global, cls)}>
      <div className={cn(theme.container, styles.container)}>
        <h2><T>Truly Global Network</T></h2>
        <p className={theme.u1}><T>Choose from 70+ million Proxies in 195
          countries</T></p>
        <div className={styles.map}>
          <Map key={'homepage'} shown_in_home={true}/>
        </div>
      </div>
    </section>;
};

const HP_faq = ()=>{
    const {theme} = useContext(Settings_context);
    return <div className={cn(styles.hp_faq, theme.container)}>
      <Faq_section color="transparent"/>
    </div>;
};

interface I_hp_final_props {
    title?: string;
    title_tag?:string;
    caption?: string;
    to?: string;
}

export const HP_final = (props: I_hp_final_props)=>{
    const {T} = use_translation_v({no_defaults: true});
    const {show_promo} = use_show_promo();
    const title = props.title || 'Get the right Proxies.<br/>Get ahead.';
    const caption = props.caption || (show_promo ? 'Get started' : 'Try now');
    const to = props.to || '/dashboard';
    return <div className={styles.hp_final}>
      <div className={styles.bg}/>
      <div className={styles.container}>
        <Dynamic_heading tag={props.title_tag || 'h2'}>
          <T>{title}</T>
        </Dynamic_heading>
        <Button
          caption={<Fragment><T>{caption}</T> <Icon_arrow_right/></Fragment>}
          size={'lg'} no_jump cls={styles.last_btn} to={to} fit
          round={false} on_click={()=>{
            perr({id: 'toolip_homepage_get_started_bottom_click'});
          }}/>
      </div>
    </div>;
};

interface i_hp_final_editor_value {
    title: string;
    caption: string;
    to: string;
}

interface i_hp_final_editor_props {
    value?: i_hp_final_editor_value;
    on_change: (value: i_hp_final_editor_value)=>void;
}

export const HP_final_editor = (props: i_hp_final_editor_props)=>{
    const {value = {title: '', caption: '', to: ''}, on_change} = props;
    type editor_key = keyof i_hp_final_editor_value;
    type editor_type = 'text' | 'textarea' | 'number' | 'boolean' | 'selector'
      | 'select_tag_selector';
    const editors = [
        ['title', 'Title', 'text'],
        ['title_tag', 'Title Tag', 'select_tag_selector'],
        ['caption', 'Button Caption', 'text'],
        ['to', 'Button Link', 'text']
    ].map(([key, label, type])=>({key: key as editor_key, label,
        type: type as editor_type}));
    return <Editor
      value={value}
      editors={editors}
      on_change={on_change}
      title="HP Final Editor"
    />;
};

export const Root = ()=>{
    useEffect(()=>{ perr_www_visit({id: 'toolip_homepage_visit'}); }, []);
    const {y} = use_scrolled();
    const ref = useRef<HTMLDivElement>();
    const {width} = use_screen();
    const intercom = use_intercom(false);
    const {get_cta} = use_show_promo();
    useEffect(()=>{
        if (!ref.current)
            return;
        ref.current.style.setProperty('--y', `${y}px`);
    }, [y, ref.current]);
    useEffect(()=>{
        if (width >= 768 && !intercom.visible)
            intercom.show();
        if (width < 768)
            intercom[y > 500 ? 'show' : 'hide']();
    }, [y, width, intercom.visible]);
    return <div className={styles.root_ind} ref={ref}>
      <Gradient_hero/>
      <Products_cards
        title={'The toolip Products'}
        subtitle=
          {'Choose what best matches your needs and goals on the house!'}
        with_icons
        get_cta={get_cta}
      />
      <HP_cards/>
      <Use_case_bubbles/>
      <HP_feature_slides/>
      <HP_global/>
      <Review_slides/>
      <HP_faq/>
      <HP_final/>
    </div>;
};

const meta: any = {
    meta: ({translate})=>{
        translate = translate ? translate : t=>t;
        return {
          title: translate('Lightning-Fast Proxies. Global IP Variety.'),
          description: translate(
              `Scale your business with Toolip's premium proxies.
              Enjoy 99.9% uptime, global IPs, and a free trial. No credit card
              required`),
          canonical_url: 'https://toolip.io/'
        };
    },
    footer_opt: {
        gradient_color: 'var(--wp--preset--color--blue-100)',
    },
    translation: {enabled: true, detect_by_country: true,
        white_list: ['en', 'ru', 'es', 'tr', 'de', 'fr', 'ja', 'he', 'zh']},
};

Root.meta = meta;
